<template>
  <div v-if="getBalance['BTC'] && getInvest">
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("Plans") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
        <div class="right">
          <router-link to="/myinvest">{{ $t("MyEarnings") }}</router-link>
        </div>
      </div>
    </div>
    <div class="container-center lg animated fadeIn">
      <div v-for="b in getInvest" v-bind:key="b._id">
        <div class="panel panel-filled" v-if="b._id == invest_id">
          <div class="panel-heading">
            <div class="coin text-center">
              {{ b.currencyIN }}
              <i class="fad fa-arrow-circle-right"></i>
              {{ b.currencyOUT }}
            </div>
          </div>
          <div class="panel-body">
            <div class="row">
              <div
                class="col-xs-12 m-t-sm"
                v-if="b.avail / 1 >= b.min_invest / 1"
              >
                <form @submit.prevent="submit" class="form-horizontal">
                  <h5>{{ $t("Note") }}</h5>
                  <p v-if="b.type == 'SWAPPING'">{{ $t("note_swapping") }}</p>
                  <p v-if="b.type == 'STAKING'">{{ $t("note_staking") }}</p>
                  <h5>{{ $t("Conditions") }}</h5>
                  <ul>
                    <!-- min swap -->
                    <li>
                      <span v-if="b.type == 'SWAPPING'">{{
                        $t("MinSwap")
                      }}</span>
                      <span v-if="b.type == 'STAKING'">{{
                        $t("MinHoldings")
                      }}</span>
                      <span class="text-accent">
                        {{ b.min_invest.toLocaleString() }}
                        {{ b.currencyIN }}
                      </span>
                    </li>
                    <!--  -->

                    <!-- period -->
                    <li>
                      <span v-if="b.type == 'SWAPPING'">{{
                        $t("InPeriod")
                      }}</span>
                      <span v-if="b.type == 'STAKING'">{{
                        $t("Capitalreturnafter")
                      }}</span>
                      <span class="text-accent m-l-xs"
                        >{{ b.period }} {{ $t("days") }}</span
                      >
                    </li>
                    <!--  -->

                    <!-- rate -->
                    <li>
                      <span>{{ $t("Rate") }}</span>
                      <span class="m-l-xs text-accent">
                        {{ b.ratio.toLocaleString() }}
                        {{ b.currencyOUT }}/{{ b.currencyIN }}
                      </span>
                    </li>
                    <!--  -->

                    <!-- DailyProfit -->
                    <li v-if="amount > 0">
                      <span>{{ $t("DailyProfit") }}</span>
                      <span class="m-l-xs text-accent">
                        {{ fixed((amount * b.ratio) / b.period) }}
                        {{ b.currencyOUT }}
                      </span>
                    </li>

                    <!-- Conditions -->
                    <li v-if="b.type == 'SWAPPING'">
                      No Return Capital for swapping.
                    </li>
                    <li v-if="b.type == 'STAKING'">
                      {{ $t("Capitalreturnafter") }}
                      <span class="m-l-xs text-accent"
                        >{{ b.period }} days</span
                      >
                    </li>
                    <li>Not allowed to cancel</li>
                    <li>{{ $t("Fee") }} {{ b.fee }}%</li>
                    <li>Commission Referral {{ b.com }}% (from Capital)</li>
                  </ul>
                  <!--  -->

                  <!-- process bar -->
                  <div class="col-xs-12 m-t-md m-b-md">
                    <h6>
                      {{ $t("Available") }}
                      <span class="text-accent"
                        >{{ fixed(b.avail / 1) }}({{ b.currencyIN }})</span
                      >
                    </h6>
                    <div class="progress m-t-xs full progress-small">
                      <div
                        v-bind:style="
                          'width: ' + (100 - (100 * b.avail) / b.total) + '%'
                        "
                        aria-valuemax="100"
                        aria-valuemin="0"
                        v-bind:aria-valuenow="100 - (100 * b.avail) / b.total"
                        role="progressbar"
                        class="progress-bar progress-bar-warning"
                      >
                        <span class="sr-only"
                          >{{ 100 - (100 * b.avail) / b.total }}% Complete
                          (success)</span
                        >
                      </div>
                    </div>
                  </div>
                  <!--  -->

                  <!-- input form  -->
                  <div class="form-group">
                    <label for="amount" class="col-xs-12"
                      ><small>{{ $t("Amount") }}({{ b.currencyIN }})</small
                      ><span class=" pull-right">
                        <i class="fad fa-wallet"></i>
                        <span class="font-bold c-white"
                          >{{ getBalance[b.currencyIN].available }}
                          {{ b.currencyIN }}</span
                        >
                      </span></label
                    >
                    <div class="col-xs-12">
                      <input
                        id="total"
                        type="number"
                        min="0"
                        step="0.00000001"
                        v-model="amount"
                        class="form-control"
                        placeholder="amount to invest"
                      />
                      <span class="unit"
                        ><span
                          class="ml-10 text-accent font-bold pointer"
                          v-on:click="
                            investAll(
                              getBalance[b.currencyIN].available,
                              b.avail
                            )
                          "
                          >MAX</span
                        ></span
                      >
                    </div>
                  </div>
                  <!--  -->

                  <!-- summary message -->
                  <div v-if="amount > 0">
                    <div
                      class="text-center m-t-sm m-b-sm"
                      v-if="b.type == 'SWAPPING'"
                    >
                      {{ $t("Swapping") }}
                      <span class="text-accent"
                        >{{ fixed(amount) }} {{ b.currencyIN }}</span
                      >
                      {{ $t("toget") }}
                      <span class="text-accent">
                        {{ fixed(b.ratio * amount) }}
                        {{ b.currencyOUT }}</span
                      >
                      {{ $t("in") }} {{ b.period }} {{ $t("days") }} <br />
                      ( {{ $t("toearn") }}
                      <span class="text-accent">
                        {{ ((b.ratio * amount) / b.period).toLocaleString() }}
                        {{ b.currencyOUT }}</span
                      >
                      {{ $t("dailyrewards") }})
                    </div>
                    <div
                      class="text-center m-t-sm m-b-sm"
                      v-if="b.type == 'STAKING'"
                    >
                      {{ $t("Staking") }}
                      <span class="text-accent"
                        >{{ fixed(amount) }} {{ b.currencyIN }}</span
                      >
                      {{ $t("toearn") }}
                      <span class="text-accent"
                        >{{ fixed((b.ratio * amount) / b.period) }}
                        {{ b.currencyOUT }}</span
                      >
                      {{ $t("dailyrewards") }}<br />
                      {{ $t("Capitalreturnafter") }} {{ b.period }}
                      {{ $t("days") }}
                    </div>
                  </div>
                  <!--  -->

                  <!-- confirm button -->
                  <button
                    v-if="loading"
                    class="btn btn-default btn-block"
                    disabled=" "
                  >
                    <i class="fad fa-spinner-third fa-spin m-r-xs"></i
                    >{{ $t("Loading") }}
                  </button>
                  <button
                    v-else-if="!amount"
                    class="btn btn-default btn-block"
                    disabled=" "
                  >
                    {{ b.type }} {{ b.currencyIN }}
                  </button>
                  <button v-else class="btn btn-accent btn-block text-accent">
                    {{ b.type }} {{ b.currencyIN }}
                  </button>
                  <!--  -->
                </form>
              </div>
              <div class="col-xs-12 m-t-sm" v-else>
                <button class="btn btn-default btn-block c-white" disabled>
                  Out of Quota
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import investbox from "@/api/investbox";
import { mapGetters, mapActions } from "vuex";
import nativeToast from "native-toast";
import func from "@/widgets/func.js";
export default {
  data() {
    return {
      invest_id: this.$route.params.investid,
      amount: null,
      loading: false
    };
  },
  computed: mapGetters(["getBalance", "getInvest"]),
  methods: {
    ...mapActions(["fetchInvest"]),
    fixed(a) {
      return func.fixed(a);
    },
    async submit() {
      this.loading = true;
      await investbox
        .submit({
          invest_id: this.invest_id,
          amount: this.amount
        })
        .then(() => {
          this.loading = false;
          this.amount = null;
          nativeToast({
            message: "Successfully.",
            position: "top",
            timeout: 3000,
            type: "success"
          });
        })
        .catch(error => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
        });
    },
    investAll(amount, avail) {
      if (avail / 1 < amount / 1) {
        this.amount = avail.toFixed(8);
      } else {
        this.amount = amount;
      }
    }
  },
  created() {
    this.fetchInvest();
  }
};
</script>

<style scoped>
.fa-wallet {
  margin-right: 10px;
}
.coin img {
  margin-left: 20px;
}
.coin {
  color: white;
  font-size: 20px;
}
.progress-small,
.progress-small .progress-bar {
  height: 30px;
}
.progress {
  border-radius: 20px;
  margin-bottom: 0px;
  background-color: transparent;
  background-image: linear-gradient(0deg, #192330, #414011 50%, #192330);
  height: 30px;
  position: relative;
}
.full .progress-bar-warning {
  background-image: linear-gradient(180deg, #ffe170, #ffb900);
  height: 22px;
  border-radius: 22px;
  position: absolute;
  top: 4px;
  left: 0px;
}
.full .progress-bar-warning {
  border-right: 0px solid #fff;
}
.progress-bar {
  padding-right: 0px;
}
</style>
